import { render, staticRenderFns } from "./PasswordChangeDialog.vue?vue&type=template&id=d05ba290&scoped=true"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordChangeDialog.vue?vue&type=style&index=0&id=d05ba290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ba290",
  null
  
)

export default component.exports